import { render, staticRenderFns } from "./FormHelperBlob.vue?vue&type=template&id=04506d70&"
import script from "./FormHelperBlob.vue?vue&type=script&lang=js&"
export * from "./FormHelperBlob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports